// Assets DMB Partners — Kit Neo (Oct 2026)
// Logos vectoriels (SVG) servis depuis /public/logos/
// Photos & OG image servis depuis /public/images/
export const ASSETS = {
    // Logos
    logo: "/logos/dmb-partners-logo.svg",
    logoPng: "/logos/dmb-partners-logo.png",
    logoWhite: "/logos/dmb-partners-logo-blanc.svg",
    logoWhitePng: "/logos/dmb-partners-logo-blanc.png",
    logoEmail: "/logos/dmb-partners-logo-email.png",
    monogramme: "/logos/dmb-monogramme.svg",

    // Images
    edina: "/images/edina-berisha.jpg",
    hugo: "/images/hugo-daugeron-mijoin.jpg",
    bfmStudio: "/images/bfm-studio.jpg",
    ogImage: "/images/og-image.png",
};

export const FOD_URL = "https://www.fodbydmb.com";
export const FOD_SIMULATOR_URL = "https://www.fodbydmb.com/simulateur";
export const BFM_ARTICLE_URL =
    "https://www.bfmtv.com/economie/professionnels/focus-entreprises/fod-le-pure-player-de-l-optimisation-des-frais-bancaires_AB-202501270025.html";
export const YOUTUBE_WATCH = "https://www.youtube.com/watch?v=IlUJPmvkMtU";
export const YOUTUBE_EMBED = "https://www.youtube.com/embed/IlUJPmvkMtU";

export const LINKEDIN = {
    edina: "https://www.linkedin.com/in/edina-berisha-59b4a778/",
    hugo: "https://www.linkedin.com/in/hugo-dm/",
    company: "https://www.linkedin.com/company/dmb-partners/",
};

export const CONTACT_EMAIL = "contact@fodbydmb.com";

// API base URL — relative /api so the deployed site uses the same origin
// (section 3 of the Neo prompt). Works both on preview (ingress Emergent) and production.
export const API_BASE = "/api";

// --- Backwards-compat aliases (used by /admin pre-Jalon 5) ---
ASSETS.logoLight = ASSETS.logo;
ASSETS.logoDark = ASSETS.logoWhite;
